import { useState, useCallback } from "react";
import { APSQAssessmentDialog } from "./plans/APSQAssessmentDialog";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const INITIAL_ASSESSMENT = {
  apsq_q1: 1, apsq_q2: 1, apsq_q3: 1, apsq_q4: 1,
  apsq_q5: 1, apsq_q6: 1, apsq_q7: 1, apsq_q8: 1,
  apsq_q9: 1, apsq_q10: 1,
  acsi_q1: 0, acsi_q2: 0, acsi_q3: 0, acsi_q4: 0,
  acsi_q5: 0, acsi_q6: 0, acsi_q7: 0, acsi_q8: 0,
  acsi_q9: 0, acsi_q10: 0, acsi_q11: 0, acsi_q12: 0,
  acsi_q13: 0, acsi_q14: 0, acsi_q15: 0, acsi_q16: 0,
  acsi_q17: 0, acsi_q18: 0, acsi_q19: 0, acsi_q20: 0,
  acsi_q21: 0, acsi_q22: 0, acsi_q23: 0, acsi_q24: 0,
  acsi_q25: 0, acsi_q26: 0, acsi_q27: 0, acsi_q28: 0,
  training_goals: [],
  preferred_exercises: [],
  time_availability_minutes: 15,
  additional_notes: "",
};

export default function OnboardingAssessment({ open, onComplete }) {
  const [assessmentData, setAssessmentData] = useState(INITIAL_ASSESSMENT);
  const [loading, setLoading] = useState(false);

  const handleChange = useCallback((field, value) => {
    setAssessmentData(prev => ({ ...prev, [field]: value }));
  }, []);

  const handleToggleArray = useCallback((field, value) => {
    setAssessmentData(prev => {
      const arr = prev[field] || [];
      return {
        ...prev,
        [field]: arr.includes(value) ? arr.filter(v => v !== value) : [...arr, value],
      };
    });
  }, []);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      await axios.post(`${API}/training-plan-assessment`, assessmentData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Assessment complete! Your personalized training plan is being generated.");
      if (onComplete) onComplete();
    } catch (e) {
      toast.error("Failed to submit assessment: " + (e.response?.data?.detail || e.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <APSQAssessmentDialog
      open={open}
      onOpenChange={() => {}}
      assessmentData={assessmentData}
      loading={loading}
      onAssessmentChange={handleChange}
      onToggleArrayValue={handleToggleArray}
      onSubmit={handleSubmit}
    />
  );
}
